import './styles/global/App.css';
import Footer from './components/layout/Footer';
import AgentWidget from './components/agent/AgentWidget';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/sections/HomePage';
import AboutMe from './components/sections/AboutMe';
import Schrodinger from './pages/Schrodinger';
import Ballys from './pages/Ballys';
import RRMS from './pages/RRMS';
import Jerry from './pages/Jerry';
import OurDate from './pages/OurDate';
import MultiBox from './pages/MultiBox';
import RouteAnalytics from './utils/analytics';

function App() {
  return (
    <div className="App">
      <Router>
        <RouteAnalytics />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/schrodinger" element={<Schrodinger />} />
          <Route path="/ballys" element={<Ballys />} />
          <Route path="/rrms" element={<RRMS />} />
          <Route path="/jerry" element={<Jerry />} />
          <Route path="/ourdate" element={<OurDate />} />
          <Route path="/multi-box" element={<MultiBox />} />
        </Routes>
      <Footer />
      <AgentWidget />
      </Router>
    </div>
  );
}

export default App;
